import React, { useEffect, useState } from 'react';
import image from '../../images/lili.png'
import { useDispatch } from 'react-redux';
import { setModalStage } from '../../store/modalSlice';
import Button from '../../share/button/Button';
import { useAccount, useReadContract } from 'wagmi';
import { keccak256, encodePacked } from 'viem';
import { LILVERSE_MINT_ADDRESS, LILVERSE_MINT_ABI, fetchOgProofs } from '../../web3/lilverseMintContract';

const OgStatus = () => {
    const dispatch = useDispatch();
    const { address } = useAccount();
    const [proofState, setProofState] = useState({ loading: true, proof: null, error: null });

    const leaf = address ? keccak256(encodePacked(['address'], [address])) : undefined;

    const { data: alreadyClaimed, isLoading: claimedLoading } = useReadContract({
        address: LILVERSE_MINT_ADDRESS,
        abi: LILVERSE_MINT_ABI,
        functionName: 'ogLeafClaimed',
        args: leaf ? [leaf] : undefined,
        query: { enabled: Boolean(leaf) },
    });

    useEffect(() => {
        if (!address) return;
        let cancelled = false;
        fetchOgProofs()
            .then((data) => {
                if (cancelled) return;
                const proof = data.proofs[address];
                setProofState({ loading: false, proof: proof || null, error: null });
            })
            .catch((err) => {
                if (cancelled) return;
                setProofState({ loading: false, proof: null, error: err.message });
            });
        return () => { cancelled = true; };
    }, [address]);

    const loading = proofState.loading || claimedLoading;
    const isEligible = Boolean(proofState.proof);

    const handleContinue = () => {
        if (!isEligible) {
            dispatch(setModalStage('OG_NOT_ELIGIBLE'));
        } else {
            dispatch(setModalStage('OG_MINT'));
        }
    };

    return (
        <div className="flex flex-col items-center gap-2">
            <img src={image} className="w-[150px] sm:w-[190px] h-auto mb-2" alt="Lili" />
            <div className="flex flex-col gap-3 items-center max-w-[500px] w-full text-center">
                {loading && (
                    <p className="font-dang text-lg sm:text-xl md:text-[1.7rem] text-white">Checking your wallet against the legacy holder list…</p>
                )}

                {!loading && proofState.error && (
                    <p role="alert" className="font-mons text-sm text-white bg-[#D14D4D] rounded-lg px-4 py-2">
                        Couldn't check eligibility: {proofState.error}. Try again in a moment.
                    </p>
                )}

                {!loading && !proofState.error && isEligible && alreadyClaimed && (
                    <p className="font-dang text-lg sm:text-xl md:text-[1.7rem] text-white">You've already claimed your OG mint with this wallet.</p>
                )}

                {!loading && !proofState.error && isEligible && !alreadyClaimed && (
                    <p className="font-dang text-lg sm:text-xl md:text-[1.7rem] text-white">Nice! This wallet held a legacy Lilverse NFT. You're eligible for the OG mint.</p>
                )}

                {!loading && !proofState.error && !isEligible && (
                    <p className="font-dang text-lg sm:text-xl md:text-[1.7rem] text-white">This wallet isn't on the legacy holder list.</p>
                )}

                {!loading && !proofState.error && (
                    <Button
                        onClick={handleContinue}
                        disabled={isEligible && alreadyClaimed}
                        size="cta"
                        className="mt-2"
                    >
                        {isEligible && alreadyClaimed ? 'Already claimed' : 'Continue'}
                    </Button>
                )}
            </div>
        </div>
    );
};

export default OgStatus;
